var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.$t("SeaExport.AddSpellCustomsOrderNo"),
        visible: _vm.innerVisible,
        "show-close": false,
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        width: "400px"
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "el-form",
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("SeaExport.PleaseForAddingAndForm"),
                required: ""
              }
            },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    clearable: "",
                    disabled: _vm.finalRuleTypes.length <= 1
                  },
                  model: {
                    value: _vm.config.ruleType,
                    callback: function($$v) {
                      _vm.$set(_vm.config, "ruleType", $$v)
                    },
                    expression: "config.ruleType"
                  }
                },
                _vm._l(_vm.finalRuleTypes, function(type) {
                  return _c("el-option", {
                    key: type.code,
                    attrs: { value: type.code, label: type.chineseName }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: { label: _vm.$t("SeaExport.PleaseSelectSuffixSeparator") }
            },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    clearable: "",
                    disabled: _vm.inputMbl === 2 || _vm.inputMbl === 3
                  },
                  model: {
                    value: _vm.config["split"],
                    callback: function($$v) {
                      _vm.$set(_vm.config, "split", $$v)
                    },
                    expression: "config['split']"
                  }
                },
                _vm._l(_vm.splitChars, function(char, index) {
                  return _c("el-option", { key: index, attrs: { value: char } })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("SeaExport.PleaseCustomsDeclarationNoSpelled"),
                required: ""
              }
            },
            [
              _c("el-input-number", {
                staticStyle: { width: "100%" },
                attrs: {
                  min: 0,
                  step: 1,
                  "step-strictly": "",
                  controls: false
                },
                model: {
                  value: _vm.config.generateCount,
                  callback: function($$v) {
                    _vm.$set(_vm.config, "generateCount", $$v)
                  },
                  expression: "config.generateCount"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handleConfirm } },
            [_vm._v(_vm._s(_vm.$t("Message.Confirm")))]
          ),
          _c(
            "el-button",
            {
              on: {
                click: function($event) {
                  _vm.innerVisible = false
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("Message.Cancel")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }